<template>
  <div class="catalog-wrapper">
    <button class="catalog-btn" @click="show = !show">
      {{ $t('catalog') }}
    </button>
    <div class="catalog-box">
      <ul class="catalog-list">
        <li v-for="node in menuItems" :key="node.slug" class="catalog-item">
          <router-link :to="`${getPath()}/${node.slug}`">
            <span class="catalog-item-title"
              ><span class="catalog-item-title-content">{{
                categoryName(node)
              }}</span></span
            >
          </router-link>
          <div class="catalog-block">
            <div class="catalog-block-wrapper">
              <div class="catalog-block-list">
                <div
                  v-for="(chunk, index) in getChunk(node.children, node.slug)"
                  :key="index"
                  class="catalog-block-list-item"
                >
                  <ul class="chunk-list">
                    <li
                      v-for="chunkItem in chunk"
                      :key="chunkItem.slug"
                      class="chunk-list-item"
                    >
                      <router-link
                        :to="
                          chunkItem.used
                            ? `${getPath()}/used/${chunkItem.slug}`
                            : `${getPath()}/${node.slug}/${chunkItem.slug}`
                        "
                        class="chunk-list-item-link"
                      >
                        <span class="chunk-list-item-title"
                          ><span class="chunk-list-item-title-content">{{
                            chunkItem.used
                              ? chunkItem.name
                              : categoryName(chunkItem)
                          }}</span></span
                        >
                      </router-link>
                      <ul class="chunk-list-item-children">
                        <li
                          v-for="chunkItemChildren in chunkItem.children"
                          :key="chunkItemChildren.slug"
                          class="chunk-list-item-child"
                        >
                          <router-link
                            :to="`${getPath()}/${node.slug}/${chunkItem.slug}/${
                              chunkItemChildren.slug
                            }`"
                            class="chunk-list-item-child-link"
                          >
                            <span class="chunk-list-item-child-name"
                              ><span class="chunk-list-item-child-name-text">{{
                                categoryName(chunkItemChildren)
                              }}</span></span
                            >
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MenuMixin from '@/components/header/MenuMixin'
import { mapState } from 'vuex'
export default {
  name: 'Catalog',
  mixins: [MenuMixin],
  data() {
    return {
      path: '/product-category',
      show: false,
    }
  },
  computed: {
    ...mapState(['lang']),
    menuItems() {
      const usedItem = this.menuNodes.find(({ slug }) => slug === 'used')
      const usedItemMapping = Object.fromEntries(
        (usedItem.children || []).map(({ slug, name }) => [slug, name])
      )
      return this.menuNodes.map((item) => {
        if (usedItemMapping[item.slug]) {
          return {
            ...item,
            children: [
              ...item.children,
              {
                name: usedItemMapping[item.slug],
                used: true,
                slug: item.slug,
              },
            ],
          }
        } else {
          return item
        }
      })
    },
  },
  methods: {
    categoryName(node) {
      return node[`name_${this.$i18n.locale}`] || node.name || '.....'
    },
    getPath() {
      return `${this.lang ? `/${this.lang}` : ''}${this.path}`
    },
    getChunk(nodes) {
      const n = 3
      const size = Math.ceil(nodes.length / n)
      const list = Array.from({ length: n }, (v, i) =>
        nodes.slice(i * size, i * size + size)
      )

      return list
    },
  },
}
</script>

<style>
.catalog-wrapper {
  padding-right: 18px;
}
.catalog-wrapper:hover .catalog-box {
  display: flex;
}
.catalog-btn {
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-radius: 10px;
}
.catalog-wrapper .catalog-btn {
  background-color: rgba(255, 67, 0, 0.9);
}
.catalog-wrapper:hover .catalog-btn {
  background-color: #444;
}
.catalog-btn:before {
  content: '\e89b';
  font-family: 'fontello-custom';
  font-size: 16px;
  margin-right: 10px;
}
.catalog-box {
  position: absolute;
  left: 0;
  z-index: 1;
  width: 100%;
  display: none;
}
.catalog-list {
  padding: 16px 0;
  width: 224px;
  margin-bottom: 0;
  background: #fff;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 6, 0.05);
  border-radius: 10px;
}
.catalog-item {
  position: static;
}
.catalog-item:before {
  display: none;
}
.catalog-item:hover .catalog-block {
  display: block;
}
.catalog-item-title {
  display: block;
  padding: 2px 12px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'Nunito', sans-serif;
  color: black;
}
.catalog-item-title:after {
  content: '\e94f';
  font-family: 'fontello';
}
.catalog-item-title-content,
.chunk-list-item-title-content {
  display: inline-block;
}
.catalog-item:hover .catalog-item-title-content:after,
.chunk-list-item:hover .chunk-list-item-title-content:after,
.chunk-list-item-child:hover .chunk-list-item-child-name-text:after {
  background-color: #ff4300;
  width: 100%;
}
.catalog-item-title-content:after,
.chunk-list-item-title-content:after,
.chunk-list-item-child-name-text:after {
  content: '';
  width: 0;
  height: 1px;
  display: block;
  transition: width 0.3s ease-in-out;
}
.catalog-block {
  display: none;
  position: absolute;
  left: 223px;
  top: 0;
  width: calc(100% - 223px);
  padding-left: 2px;
  height: 100%;
}
.catalog-block-wrapper {
  padding: 20px 16px;
  background: #fff;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 6, 0.05);
  overflow: auto;
  max-height: 500px;
  border-radius: 10px;
}
.catalog-block-list {
  margin: 0;
  padding: 0;
  display: flex;
  height: 100%;
}
.catalog-block-list-item {
  width: 33%;
  font-size: 12px;
}
.catalog-block-list-item:before {
  display: none;
}
.chunk-list {
  margin: 0;
  padding: 0;
}
.chunk-list-item {
  padding: 4px 8px;
}
.chunk-list-item-link,
.chunk-list-item-link:hover,
.chunk-list-item-child-link,
.chunk-list-item-child-link:hover {
  color: #000 !important;
}
.chunk-list-item:before {
  display: none;
}
.chunk-list-item-children {
  margin: 0;
  padding: 0;
}
.chunk-list-item-child {
  padding: 0;
}
.chunk-list-item-child-link {
  font-size: 13px;
}
</style>
